import { UseGetPostsDetailsProps } from 'src/client/publication/types'
import { AVATAR_SIZE } from 'src/utils/constants'
import { PostsEndpoints } from 'src/services/posts'
import { AuthStatus } from '@hotmart/space-lib/dist/enum'
import { COMMUNITY_TYPE } from 'src/client/types'
import { useHotRequest } from '@hotmart-org-ca/hot-club-http/client/hooks'
import { APP_MEMBERSHIP_COMMUNITY_CONSUME_HOT_HTTP_INSTANCES } from 'src/config/request/hotClubHttp'
import { CustomResponseError } from 'src/config/request'
import { useUser } from '../useUser'
import { PostProps } from '../usePosts'
import { REQUEST_CONFIG } from './useGetPostDetails.constants'

const useGetPostsDetails = ({
  id,
  communityType,
  avatarSize = AVATAR_SIZE,
  enabled = true
}: UseGetPostsDetailsProps) => {
  const { authStatus } = useUser()

  const isUnauthenticated = authStatus === AuthStatus.UNAUTHENTICATED
  const url = isUnauthenticated
    ? PostsEndpoints.getPostDetailsPublic(id)
    : PostsEndpoints.getPostDetails(id)

  return useHotRequest<PostProps, CustomResponseError>(url, {
    cacheKey: [url],
    instanceName: APP_MEMBERSHIP_COMMUNITY_CONSUME_HOT_HTTP_INSTANCES.API_SPARKLE,
    params: {
      avatarDimensions: `${avatarSize}x${avatarSize}`
    },
    queryOptions: {
      enabled: isUnauthenticated ? communityType === COMMUNITY_TYPE.PUBLIC && enabled : enabled,
      ...REQUEST_CONFIG
    }
  })
}

export default useGetPostsDetails
